import { render, staticRenderFns } from "./NotifyStep.vue?vue&type=template&id=6e03c50f"
import script from "./NotifyStep.vue?vue&type=script&lang=js"
export * from "./NotifyStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports